





































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import BtnDefault from '@/components/UI/BtnDefault.vue';
import IClose from '@/components/icons/IClose.vue'
import ISwitcher from '@/components/icons/ISwitcher.vue'


@Component({
  name: "modal",
  components: {
    BtnDefault,
    'i-close': IClose,
    'i-switcher': ISwitcher,
  }
})
export default class Modal extends Vue {

  @Prop({type: [String], default: ''}) protected title!: string
  @Prop({type: [String], default: ''}) protected text!: string
  @Prop({type: [String], default: ''}) protected inputBtn!: string
  @Prop({type: [String], default: ''}) protected cancel!: string
  @Prop({type: [String], default: ''}) protected action!: string
  @Prop({type: [String], default: '477'}) protected maxWidth!: string

  @Prop({type: [Boolean], default: false}) protected dialog!: boolean
  @Prop({type: [Boolean], default: false}) protected disableAction!: boolean
  @Prop({type: [Boolean], default: true}) protected isClose!: boolean
  @Prop({type: [Boolean], default: true}) protected isRedAction!: boolean
  @Prop({type: [Boolean], default: true}) protected isBtns!: boolean
  @Prop({type: [Boolean], default: true}) protected isDivider!: boolean
  @Prop({type: [Boolean], default: false}) protected actionLoading!: boolean
  @Prop({type: [Boolean], default: false}) protected isLoading!: boolean
  @Prop({type: [Boolean], default: false}) protected isInput!: boolean

  email:string = ''
  checkedEmail:boolean = true
  loading:boolean = false
  switcherOn:boolean = false
  dialog2 = this.dialog
  inputText:string = ''

  @Watch('dialog')
  getDialog() {
    if(!this.dialog){
      this.closeDialog()
    }else {
      this.dialog2=true
    }
  }
  @Watch('dialog2')
  getDialog2() {
    if(!this.dialog2) {
      this.$emit('closeDialog')
    }
  }

  checkEmail() {
    if(this.email !== ''){
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(re.test(String(this.email).toLowerCase())){
        this.checkedEmail = true
      }else {
        this.checkedEmail = false
        this.loading = false
      }
    } else {
      this.checkedEmail = false
      this.loading = false
    }
  }

  send() {
    this.checkEmail()
    if(this.checkedEmail) {
      this.$emit('send', this.email)
    }
  }

  sendInputText() {
    this.$emit('sendInputText', this.inputText)
    this.$emit('closeDialog')
  }

  actionModal() {
    // this.closeDialog()
    this.$emit('actionModal')
  }

  closeDialog() {
    this.dialog2 = false
    this.$emit('closeDialog')
  }

  changeSwitcher() {
    this.switcherOn = !this.switcherOn
  }

}
